import { ROUTES } from '@constants/constants';
import useLocale from '@hooks/useLocale';
import { NewsPage } from '@type-declarations/page';
import { Article, WithContext } from 'schema-dts';

export default function NewsSchema({ page }: { page: NewsPage }) {
  const locale = useLocale();

  const schema: WithContext<Article> = {
    '@type': 'Article',
    '@context': 'https://schema.org',
    name: page.title,
    description: page.introText,
    url: `${
      process.env.ENVIRONMENT_URL + ROUTES.LocationOverviewPage[locale]
    }/${page.slug}`,
    image: page.image?.url,
    datePublished: page.publishOn,
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}
